package com.anjuros.website.templates.template5.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.anjuros.website.templates.template5.modules.getColor
import com.anjuros.website.templates.template5.styles.Template5CallButton
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template5PrimaryButton(
    text: String,
    backgroundColor: CSSColorValue = Template5Theme.Primary.getColor(),
    path: String
) {

    Link(
        modifier = Modifier
            .textDecorationLine(TextDecorationLine.None),
        path = path,

        ) {
        Button(
            attrs = Template5CallButton.toModifier()
                .backgroundColor(backgroundColor)
                .color(Colors.White)

                .border(
                    width = 2.px,
                    style = LineStyle.Solid,
                    color = Template5Theme.Primary.getColor()
                )
                .boxShadow(
                    2.px, 2.px, 5.0.px, 1.0.px, color = Theme.DarkGrey.rgb, false
                )
                .padding(
                    leftRight = 34.px,
                    topBottom = 18.px
                )
                .borderRadius(60.px)
                .border(0.px)
                .fontSize(18.px)
                .fontWeight(FontWeight.Bold)
                .cursor(Cursor.Pointer)
                .toAttrs()
        ) {
            Text(text)
        }
    }
}

@Composable
fun Template5SecondaryButton(
    modifier: Modifier = Modifier,
    text: String,
    path: String
) {
    Link(
        modifier = modifier
            .zIndex(5)
            .textDecorationLine(TextDecorationLine.None),
        path = path,

        ) {
        Button(
            attrs = Template5CallButton.toModifier()
                .backgroundColor(Colors.Transparent)
                .color(Template5Theme.Primary.getColor())
                .border(
                    width = 2.px,
                    style = LineStyle.Solid,
                    color = Template5Theme.Primary.getColor()
                )
                .boxShadow(
                    2.px, 2.px, 5.0.px, 1.0.px, color = Theme.DarkGrey.rgb, false
                )
                .padding(
                    leftRight = 34.px,
                    topBottom = 16.px
                )
                .borderRadius(60.px)
                .fontSize(18.px)
                .fontWeight(FontWeight.Bold)
                .cursor(Cursor.Pointer)
                .toAttrs()
        ) {
            Text(text)
        }
    }
}
